import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PRODUCT_NAME } from "@/config";
import { MiniMarkdown } from "@/components/MiniMarkdown";
import { PublicFooter } from "@/components/PublicFooter";
import { PRIVACY_MD } from "@/content/privacyPolicy";
import { useAuth } from "@/context/AuthContext";

export default function Confidentialite() {
  const { user } = useAuth();
  useEffect(() => {
    const prev = document.title;
    document.title = `Politique de confidentialité | ${PRODUCT_NAME}`;
    return () => { document.title = prev; };
  }, []);
  return (
    <div className="min-h-screen bg-[#FBFAF8] text-ink font-sans" data-testid="privacy-page">
      <header className="border-b border-black/5 bg-white/80 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" data-testid="privacy-home-link" className="font-serif text-2xl font-extrabold text-ink">{PRODUCT_NAME}<span className="text-coral-strong">.</span></Link>
          {user ? (
            <Link to="/" data-testid="privacy-app-link" className="text-sm font-bold text-white bg-coral-strong px-4 py-2 rounded-full hover:bg-coral-hover active:scale-95 transition-all">Mon espace</Link>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login" className="text-sm font-semibold text-slate-600 hover:text-ink transition-colors">Se connecter</Link>
              <Link to="/login?register=1" className="text-sm font-bold text-white bg-coral-strong px-4 py-2 rounded-full hover:bg-coral-hover active:scale-95 transition-all">Essayer gratuitement</Link>
            </div>
          )}
        </div>
      </header>
      <main className="max-w-[720px] mx-auto px-6 py-16" data-testid="privacy-content">
        <MiniMarkdown source={PRIVACY_MD} />
      </main>
      <PublicFooter />
    </div>
  );
}
